import { render, staticRenderFns } from "./RoomInventory.vue?vue&type=template&id=feda4c9e&scoped=true"
import script from "./RoomInventory.vue?vue&type=script&lang=js"
export * from "./RoomInventory.vue?vue&type=script&lang=js"
import style0 from "./RoomInventory.vue?vue&type=style&index=0&id=feda4c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feda4c9e",
  null
  
)

export default component.exports